// extracted by mini-css-extract-plugin
module.exports = {"alert":"EvaluationAlert_alert__2m1ZZ","approved":"EvaluationAlert_approved__-pk1x","failed":"EvaluationAlert_failed__zsm3Z"};